<template>
  <div>
    <v-icon v-if="mood === 'happy'" size="14px" icon="material-symbols:check-circle" color="success" />
    <v-icon v-else-if="mood === 'sad'" size="14px" icon="$close-circle" color="error" />
    <span v-else class="text-textDark text-body-3 opacity-80">N/A</span>
  </div>
</template>

<script setup>
defineProps({
  mood: {
    type: String,
    default: 'neutral',
  },
});
</script>
